import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import { useRecoilValue } from "recoil";
import { FontAwesome, Entypo, Ionicons } from "@expo/vector-icons";
import RNPickerSelect from "react-native-picker-select";
import { ExportExcel } from "../action/authAction";
import { tokenState } from "../reducer/recoil";
const { width, height } = Dimensions.get("window");
export default function tabbarOption({
  dropdownGender,
  dropdownCountries,
  onPressAdd,
  navigation,
  CompeAthlete,
  Competition,
  CompetitionUser,
  Athlete,
  CompeCountriesStatus,
  FinalSub,
  FinalUser,
  buttonTabbar,
  onChangeText,
  onfilter,
  filterdata,
  onEvent,
  country,
  AthleteUser,
  competition_id,
  association_id,
  setGender,
  finalChange,
  prelimChange,
  setTypes,
}) {
  const token = useRecoilValue(tokenState);
  const placeholderGender = {
    label: "GENDER",
    value: null,
    color: "#9EA0A4",
  };
  const placeholderState = {
    label: "All Status",
    value: null,
    color: "#9EA0A4",
  };
  const placeholderCountries = {
    label: "Countries",
    value: null,
    color: "#9EA0A4",
  };
  const placeholderEvent = {
    label: "All Events",
    value: null,
    color: "#9EA0A4",
  };
  const placeholderFinal = {
    label: "ALL FINAL STATUS",
    value: null,
    color: "#9EA0A4",
  };
  const placeholderPrelim = {
    label: "ALL PRELIM STATUS",
    value: null,
    color: "#9EA0A4",
  };
  const placeholderType = {
    label: "All TYPE",
    value: null,
    color: "#9EA0A4",
  };
  const [state, setState] = useState([
    { label: "ACTIVE", value: "Active" },
    { label: "INACTIVE", value: "Inactive" },
  ]);
  const [gender, setGender1] = useState([
    { label: "MALE", value: "Male" },
    { label: "FEMALE", value: "Female" },
  ]);
  const [countries, setCountries] = useState(country);
  const [event, setEvent] = useState(filterdata);
  const [prelim, setprelim] = useState([
    { label: "Prelim Entry Submit", value: "ACTIVE" },
    { label: "Prelim Entry Not Submit", value: "INACTIVE" },
  ]);
  const [final, setFinal] = useState([
    { label: "Final Entry Submit", value: "ACTIVE" },
    { label: "Final Entry Submit", value: "INACTIVE" },
  ]);
  const [type, setType] = useState([
    { label: "ATHLETE", value: "Athlete" },
    { label: "OFFICIAL", value: "Official" },
  ]);

  useEffect(() => {
    console.log("filterdata", filterdata);
    setEvent(filterdata);
  }, []);

  return width >= 1280 ? (
    <View style={{ flexDirection: "row", marginTop: 37 }}>
      {FinalSub || FinalUser || AthleteUser ? (
        ""
      ) : (
        <RNPickerSelect
          onValueChange={(value) => onfilter(value)}
          placeholder={
            Athlete || dropdownCountries || CompeAthlete || CompeCountriesStatus
              ? placeholderCountries
              : placeholderState
          }
          items={
            Athlete || dropdownCountries || CompeAthlete || CompeCountriesStatus
              ? countries
              : state
          }
          style={{
            inputWeb: {
              width: width * 0.17,
              height: 50,
              borderWidth: 1,
              borderColor: "#2B6AB1",
              color: "#2B6AB1",
              fontFamily: "Prompt",
              fontSize: width < 1600 ? 16 : 20,
              marginLeft: 30,
              paddingLeft: 10,
            },
            iconContainer: {
              backgroundColor: "#FFF",
              alignItems: "center",
              justifyContent: "center",
              borderWidth: 1,
              borderColor: "#2B6AB1",
              width: 50,
              height: 50,
            },
          }}
          Icon={() => {
            return (
              <FontAwesome
                name="caret-down"
                size={24}
                color="#2B6AB1"
                style={{ alignSelf: "center" }}
              />
            );
          }}
        />
      )}
      {CompeCountriesStatus && (
        <View style={{ flexDirection: "row" }}>
          <RNPickerSelect
            placeholder={placeholderPrelim}
            items={prelim}
            onValueChange={prelimChange}
            style={{
              inputWeb: {
                width: width * 0.17,
                height: 50,
                borderWidth: 1,
                borderColor: "#2B6AB1",
                color: "#2B6AB1",
                fontFamily: "Prompt",
                fontSize: width < 1600 ? 16 : 20,
                marginLeft: 30,
                paddingLeft: 10,
              },
              iconContainer: {
                backgroundColor: "#FFF",
                alignItems: "center",
                justifyContent: "center",
                borderWidth: 1,
                borderColor: "#2B6AB1",
                width: 50,
                height: 50,
              },
            }}
            Icon={() => {
              return (
                <FontAwesome
                  name="caret-down"
                  size={24}
                  color="#2B6AB1"
                  style={{ alignSelf: "center" }}
                />
              );
            }}
          />
          <RNPickerSelect
            placeholder={placeholderFinal}
            items={final}
            onValueChange={finalChange}
            style={{
              inputWeb: {
                width: width * 0.17,
                height: 50,
                borderWidth: 1,
                borderColor: "#2B6AB1",
                color: "#2B6AB1",
                fontFamily: "Prompt",
                fontSize: width < 1600 ? 16 : 20,
                marginLeft: 30,
                paddingLeft: 10,
              },
              iconContainer: {
                backgroundColor: "#FFF",
                alignItems: "center",
                justifyContent: "center",
                borderWidth: 1,
                borderColor: "#2B6AB1",
                width: 50,
                height: 50,
              },
            }}
            Icon={() => {
              return (
                <FontAwesome
                  name="caret-down"
                  size={24}
                  color="#2B6AB1"
                  style={{ alignSelf: "center" }}
                />
              );
            }}
          />
        </View>
      )}
      {CompeAthlete || FinalSub || FinalUser ? (
        <RNPickerSelect
          placeholder={placeholderEvent}
          items={event}
          onValueChange={(value) => onEvent(value)}
          style={{
            inputWeb: {
              width: width * 0.17,
              height: 50,
              borderWidth: 1,
              borderColor: "#2B6AB1",
              color: "#2B6AB1",
              fontFamily: "Prompt",
              fontSize: width < 1600 ? 16 : 20,
              marginLeft: CompeAthlete || FinalSub || FinalUser ? 30 : 10,
              paddingLeft: 10,
            },
            iconContainer: {
              backgroundColor: "#FFF",
              alignItems: "center",
              justifyContent: "center",
              borderWidth: 1,
              borderColor: "#2B6AB1",
              width: 50,
              height: 50,
            },
          }}
          Icon={() => {
            return (
              <FontAwesome
                name="caret-down"
                size={24}
                color="#2B6AB1"
                style={{ alignSelf: "center" }}
              />
            );
          }}
        />
      ) : (
        ""
      )}
      {FinalSub && (
        <RNPickerSelect
          placeholder={placeholderType}
          onValueChange={(value) => setTypes(value)}
          items={type}
          style={{
            inputWeb: {
              width: width * 0.17,
              height: 50,
              borderWidth: 1,
              borderColor: "#2B6AB1",
              color: "#2B6AB1",
              fontFamily: "Prompt",
              fontSize: width < 1600 ? 16 : 20,
              marginLeft: 30,
              paddingLeft: 10,
            },
            iconContainer: {
              backgroundColor: "#FFF",
              alignItems: "center",
              justifyContent: "center",
              borderWidth: 1,
              borderColor: "#2B6AB1",
              width: 50,
              height: 50,
            },
          }}
          Icon={() => {
            return (
              <FontAwesome
                name="caret-down"
                size={24}
                color="#2B6AB1"
                style={{ alignSelf: "center" }}
              />
            );
          }}
        />
      )}
      {Athlete || CompeAthlete || FinalUser ? (
        <RNPickerSelect
          placeholder={placeholderGender}
          onValueChange={(value) => setGender(value)}
          items={gender}
          style={{
            inputWeb: {
              width: width * 0.1,
              height: 50,
              borderWidth: 1,
              borderColor: "#2B6AB1",
              color: "#2B6AB1",
              fontFamily: "Prompt",
              fontSize: width < 1600 ? 16 : 20,
              marginLeft: CompeAthlete || FinalUser ? 30 : 10,
              paddingLeft: 10,
            },
            iconContainer: {
              backgroundColor: "#FFF",
              alignItems: "center",
              justifyContent: "center",
              borderWidth: 1,
              borderColor: "#2B6AB1",
              width: 50,
              height: 50,
            },
          }}
          Icon={() => {
            return (
              <FontAwesome
                name="caret-down"
                size={24}
                color="#2B6AB1"
                style={{ alignSelf: "center" }}
              />
            );
          }}
        />
      ) : (
        ""
      )}
      {CompeAthlete || CompeCountriesStatus || FinalSub ? (
        ""
      ) : (
        <TextInput
          placeholder={
            dropdownCountries ? "Search User Name.." : "Search Name.."
          }
          onChangeText={(text) => {
            console.log("text >>", text);
            onChangeText(text);
          }}
          placeholderTextColor="#2B6AB1"
          style={[
            styles.textInputSearch,
            { marginLeft: Athlete ? 10 : 30, fontSize: width < 1600 ? 16 : 20 },
          ]}
        />
      )}
      <TouchableOpacity
        style={[
          styles.buttonSearch,
          {
            marginLeft:
              CompeAthlete || CompeCountriesStatus || FinalSub ? 20 : 0,
          },
        ]}
      >
        <Image
          resizeMode={"contain"}
          style={{ width: 35, height: 34.85, alignSelf: "center" }}
          source={require("../img/magnifier.png")}
        />
      </TouchableOpacity>
      {buttonTabbar && (
        <View style={{ flexDirection: "row" }}>
          {dropdownGender == "show" ? (
            <View></View>
          ) : dropdownCountries ? (
            <TouchableOpacity onPress={onPressAdd} style={styles.button}>
              <Text style={styles.textButton}>Add</Text>
            </TouchableOpacity>
          ) : (
            <View>
              {CompeAthlete ||
              Athlete ||
              CompeCountriesStatus ||
              FinalSub ||
              FinalUser ? (
                ""
              ) : (
                <TouchableOpacity
                  onPress={() => {
                    navigation.navigate("CompetitionCreate");
                  }}
                  navigation={navigation}
                  style={styles.button}
                >
                  <Text style={styles.textButton}>CREATE</Text>
                </TouchableOpacity>
              )}
            </View>
          )}
          {CompeAthlete ||
          Competition ||
          Athlete ||
          CompeCountriesStatus ||
          FinalSub ? (
            <TouchableOpacity
              onPress={async () => {
                console.log("Test");
                if (FinalSub) {
                  const response = await ExportExcel({
                    token: token.token,
                    competition_id,
                    association_id,
                    FinalSub: FinalSub || null,
                    CompeAthlete: CompeAthlete || null,
                  });
                  console.log(response);
                } else if (CompeAthlete) {
                  const response = await ExportExcel({
                    token: token.token,
                    competition_id,
                    association_id,
                    FinalSub: FinalSub || null,
                    CompeAthlete: CompeAthlete || null,
                  });
                  console.log(response);
                } else {
                  const response = await ExportExcel({
                    token: token.token,
                    competition_id,
                    association_id,
                    FinalSub: FinalSub || null,
                    CompeAthlete: CompeAthlete || null,
                  });
                  console.log(response);
                }
              }}
              style={styles.button}
            >
              <Text style={styles.textButton}>Export</Text>
            </TouchableOpacity>
          ) : (
            ""
          )}
        </View>
      )}
    </View>
  ) : (
    <View
      style={{
        flexDirection: "row",
        marginVertical: 37,
        justifyContent: "space-between",
        marginHorizontal: 20,
      }}
    >
      {FinalSub || FinalUser || AthleteUser ? (
        ""
      ) : (
        <View>
          <RNPickerSelect
            onValueChange={(value) => onfilter(value)}
            placeholder={
              Athlete ||
              dropdownCountries ||
              CompeAthlete ||
              CompeCountriesStatus
                ? placeholderCountries
                : placeholderState
            }
            items={
              Athlete ||
              dropdownCountries ||
              CompeAthlete ||
              CompeCountriesStatus
                ? countries
                : state
            }
            style={{
              inputWeb: {
                width: 150,
                height: 40,
                borderWidth: 1,
                borderColor: "#2B6AB1",
                color: "#2B6AB1",
                fontFamily: "Prompt",
                fontSize: 10,
                paddingLeft: 10,
              },
              iconContainer: {
                backgroundColor: "#FFF",
                alignItems: "center",
                justifyContent: "center",
                borderWidth: 1,
                borderColor: "#2B6AB1",
                width: 40,
                height: 40,
              },
            }}
            Icon={() => {
              return (
                <FontAwesome
                  name="caret-down"
                  size={18}
                  color="#2B6AB1"
                  style={{ alignSelf: "center" }}
                />
              );
            }}
          />
          {CompeCountriesStatus && (
            <RNPickerSelect
              placeholder={placeholderFinal}
              items={final}
              style={{
                inputWeb: {
                  width: 150,
                  height: 40,
                  borderWidth: 1,
                  borderColor: "#2B6AB1",
                  color: "#2B6AB1",
                  fontFamily: "Prompt",
                  fontSize: 10,
                  paddingLeft: 10,
                  marginTop: 20,
                },
                iconContainer: {
                  backgroundColor: "#FFF",
                  alignItems: "center",
                  justifyContent: "center",
                  borderWidth: 1,
                  borderColor: "#2B6AB1",
                  width: 40,
                  height: 40,
                  marginTop: 20,
                },
              }}
              Icon={() => {
                return (
                  <FontAwesome
                    name="caret-down"
                    size={18}
                    color="#2B6AB1"
                    style={{ alignSelf: "center" }}
                  />
                );
              }}
            />
          )}
          {Athlete ? (
            <TextInput
              placeholder={
                dropdownCountries ? "Search User Name.." : "Search Name.."
              }
              onChangeText={(text) => {
                console.log("text >>", text);
                onChangeText(text);
              }}
              placeholderTextColor="#2B6AB1"
              style={[stylesResponsive.textInputSearch, { marginTop: 20 }]}
            />
          ) : (
            <View></View>
          )}
          {CompeAthlete && (
            <RNPickerSelect
              placeholder={placeholderGender}
              onValueChange={(value) => setGender(value)}
              items={gender}
              style={{
                inputWeb: {
                  width: 150,
                  height: 40,
                  borderWidth: 1,
                  borderColor: "#2B6AB1",
                  color: "#2B6AB1",
                  fontFamily: "Prompt",
                  fontSize: 10,
                  paddingLeft: 10,
                  marginTop: 20,
                },
                iconContainer: {
                  backgroundColor: "#FFF",
                  alignItems: "center",
                  justifyContent: "center",
                  borderWidth: 1,
                  borderColor: "#2B6AB1",
                  width: 40,
                  height: 40,
                  marginTop: 20,
                },
              }}
              Icon={() => {
                return (
                  <FontAwesome
                    name="caret-down"
                    size={18}
                    color="#2B6AB1"
                    style={{ alignSelf: "center" }}
                  />
                );
              }}
            />
          )}
          {dropdownCountries && (
            <TouchableOpacity
              onPress={onPressAdd}
              style={stylesResponsive.button}
            >
              <Text style={stylesResponsive.textButton}>Add</Text>
            </TouchableOpacity>
          )}
          {Competition && (
            <TouchableOpacity
              onPress={() => {
                navigation.navigate("CompetitionCreate");
              }}
              navigation={navigation}
              style={stylesResponsive.button}
            >
              <Text style={stylesResponsive.textButton}>CREATE</Text>
            </TouchableOpacity>
          )}
        </View>
      )}
      {Competition || CompetitionUser || dropdownCountries ? (
        <View>
          <TextInput
            placeholder={
              dropdownCountries ? "Search User Name.." : "Search Name.."
            }
            onChangeText={(text) => {
              console.log("text >>", text);
              onChangeText(text);
            }}
            placeholderTextColor="#2B6AB1"
            style={[stylesResponsive.textInputSearch]}
          />
          {Competition && (
            <TouchableOpacity
              onPress={async () => {
                console.log("Test");
                const response = await ExportExcel({
                  token: token.token,
                  competition_id,
                  association_id,
                });
                console.log(response);
              }}
              style={stylesResponsive.button}
            >
              <Text style={stylesResponsive.textButton}>Export</Text>
            </TouchableOpacity>
          )}
        </View>
      ) : (
        <View></View>
      )}
      {CompeCountriesStatus && (
        <View>
          <RNPickerSelect
            placeholder={placeholderPrelim}
            items={prelim}
            style={{
              inputWeb: {
                width: 150,
                height: 40,
                borderWidth: 1,
                borderColor: "#2B6AB1",
                color: "#2B6AB1",
                fontFamily: "Prompt",
                fontSize: 10,
                paddingLeft: 10,
              },
              iconContainer: {
                backgroundColor: "#FFF",
                alignItems: "center",
                justifyContent: "center",
                borderWidth: 1,
                borderColor: "#2B6AB1",
                width: 40,
                height: 40,
              },
            }}
            Icon={() => {
              return (
                <FontAwesome
                  name="caret-down"
                  size={18}
                  color="#2B6AB1"
                  style={{ alignSelf: "center" }}
                />
              );
            }}
          />
          {CompeCountriesStatus && (
            <TouchableOpacity
              onPress={async () => {
                console.log("Test");
                const response = await ExportExcel({
                  token: token.token,
                  competition_id,
                  association_id,
                });
                console.log(response);
              }}
              style={stylesResponsive.button}
            >
              <Text style={stylesResponsive.textButton}>Export</Text>
            </TouchableOpacity>
          )}
        </View>
      )}
      {CompeAthlete || FinalSub || FinalUser ? (
        <View>
          <RNPickerSelect
            placeholder={placeholderEvent}
            onValueChange={(value) => onEvent(value)}
            items={event}
            style={{
              inputWeb: {
                width: 150,
                height: 40,
                borderWidth: 1,
                borderColor: "#2B6AB1",
                color: "#2B6AB1",
                fontFamily: "Prompt",
                fontSize: 10,
                paddingLeft: 10,
              },
              iconContainer: {
                backgroundColor: "#FFF",
                alignItems: "center",
                justifyContent: "center",
                borderWidth: 1,
                borderColor: "#2B6AB1",
                width: 40,
                height: 40,
              },
            }}
            Icon={() => {
              return (
                <FontAwesome
                  name="caret-down"
                  size={18}
                  color="#2B6AB1"
                  style={{ alignSelf: "center" }}
                />
              );
            }}
          />
          {CompeAthlete || FinalSub ? (
            <TouchableOpacity
              onPress={async () => {
                console.log("Test");
                const response = await ExportExcel({
                  token: token.token,
                  competition_id,
                  association_id,
                });
                console.log(response);
              }}
              style={stylesResponsive.button}
            >
              <Text style={stylesResponsive.textButton}>Export</Text>
            </TouchableOpacity>
          ) : (
            ""
          )}
          {FinalUser && (
            <TextInput
              placeholder={
                dropdownCountries ? "Search User Name.." : "Search Name.."
              }
              onChangeText={(text) => {
                console.log("text >>", text);
                onChangeText(text);
              }}
              placeholderTextColor="#2B6AB1"
              style={[stylesResponsive.textInputSearch, { marginTop: 20 }]}
            />
          )}
        </View>
      ) : (
        ""
      )}
      {FinalSub && (
        <RNPickerSelect
          placeholder={placeholderType}
          items={type}
          style={{
            inputWeb: {
              width: 150,
              height: 40,
              borderWidth: 1,
              borderColor: "#2B6AB1",
              color: "#2B6AB1",
              fontFamily: "Prompt",
              fontSize: 10,
              paddingLeft: 10,
            },
            iconContainer: {
              backgroundColor: "#FFF",
              alignItems: "center",
              justifyContent: "center",
              borderWidth: 1,
              borderColor: "#2B6AB1",
              width: 40,
              height: 40,
            },
          }}
          Icon={() => {
            return (
              <FontAwesome
                name="caret-down"
                size={18}
                color="#2B6AB1"
                style={{ alignSelf: "center" }}
              />
            );
          }}
        />
      )}
      {Athlete || FinalUser ? (
        <View>
          <RNPickerSelect
            placeholder={placeholderGender}
            onValueChange={(value) => setGender(value)}
            items={gender}
            style={{
              inputWeb: {
                width: 150,
                height: 40,
                borderWidth: 1,
                borderColor: "#2B6AB1",
                color: "#2B6AB1",
                fontFamily: "Prompt",
                fontSize: 10,
                paddingLeft: 10,
              },
              iconContainer: {
                backgroundColor: "#FFF",
                alignItems: "center",
                justifyContent: "center",
                borderWidth: 1,
                borderColor: "#2B6AB1",
                width: 40,
                height: 40,
              },
            }}
            Icon={() => {
              return (
                <FontAwesome
                  name="caret-down"
                  size={18}
                  color="#2B6AB1"
                  style={{ alignSelf: "center" }}
                />
              );
            }}
          />
          {Athlete && (
            <TouchableOpacity
              onPress={async () => {
                console.log("Test");
                const response = await ExportExcel({
                  token: token.token,
                  competition_id,
                  association_id,
                });
                console.log(response);
              }}
              style={stylesResponsive.button}
            >
              <Text style={stylesResponsive.textButton}>Export</Text>
            </TouchableOpacity>
          )}
          {/* {FinalUser && (
            <TouchableOpacity
              onPress={onPressAdd}
              style={stylesResponsive.button}
            >
              <Text style={stylesResponsive.textButton}>Add</Text>
            </TouchableOpacity>
          )} */}
        </View>
      ) : (
        ""
      )}

      {/* <TouchableOpacity
        style={[
          styles.buttonSearch,
          {
            marginLeft:
              CompeAthlete || CompeCountriesStatus || FinalSub ? 20 : 0,
          },
        ]}
      >
        <Image
          style={{ width: 35, height: 34.85, alignSelf: "center" }}
          source={require("../img/magnifier.png")}
        />
      </TouchableOpacity> */}
      {/* {buttonTabbar && (
        <View style={{ flexDirection: "row" }}>
          {dropdownGender == "show" ? (
            <View></View>
          ) : dropdownCountries || FinalUser ? (
            <TouchableOpacity onPress={onPressAdd} style={styles.button}>
              <Text style={styles.textButton}>Add</Text>
            </TouchableOpacity>
          ) : (
            <View>
              {CompeAthlete ||
              Athlete ||
              CompeCountriesStatus ||
              FinalSub ||
              FinalUser ? (
                ""
              ) : (
                <TouchableOpacity
                  onPress={() => {
                    navigation.navigate("CompetitionCreate");
                  }}
                  navigation={navigation}
                  style={styles.button}
                >
                  <Text style={styles.textButton}>CREATE</Text>
                </TouchableOpacity>
              )}
            </View>
          )}
          {CompeAthlete ||
          Competition ||
          Athlete ||
          CompeCountriesStatus ||
          FinalSub ? (
            <TouchableOpacity style={styles.button}>
              <Text style={styles.textButton}>Export</Text>
            </TouchableOpacity>
          ) : (
            ""
          )}
        </View>
      )} */}
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  textInputSearch: {
    width: width * 0.14,
    height: 50,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#2B6AB1",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: 10,
    marginRight: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  buttonSearch: {
    width: 51,
    height: 50,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#2B6AB1",
    justifyContent: "center",
    borderRadius: 7,
    marginRight: 30,
  },
  button: {
    width: 130,
    height: 50,
    borderRadius: 33,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#2B6AB1",
    justifyContent: "center",
    marginRight: 10,
  },
  textButton: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2D69AE",
    alignSelf: "center",
  },
});
const stylesResponsive = StyleSheet.create({
  textInputSearch: {
    width: 150,
    height: 40,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#2B6AB1",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: 10,
    fontSize: 10,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  button: {
    width: 150,
    height: 40,
    borderRadius: 33,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#2B6AB1",
    alignSelf: "center",
    justifyContent: "center",
    marginTop: 20,
  },
  textButton: {
    fontSize: 10,
    fontFamily: "Prompt",
    color: "#2D69AE",
    alignSelf: "center",
  },
});
